<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/170903-feature-down-syndrome.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">消失中的唐氏综合症 香港孕妇产检与中止怀孕现况</div>
                   <div class="post_info">Posted at 09:00h in 无创产前检测</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                      
                      唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失，那在香港的情况又如何？<br /><br />

                      香港法例容许怀孕24周内，在有充份理由、包括确认婴孩出生后将患有严重疾病的情况下选择人工流产。《香港01》访问了香港唐氏综合症协会及一位资深的妇产科医生，听听他们的意见。
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/170903-ultrasound.jpg"/>
                        <div class="bottom_tip">唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失，那在香港的情况又如何？</div>
                    </div> 

                    <div class="post_wrapper_1">
                      在香港，唐氏综合症被归类患有智力缺陷的残疾人士，因此无法准确得知患者的实际数字。香港唐氏综合症协会成立至今已30年，致力为唐氏综合症人士及家庭提供支援和服务。
                    </div>
                  
                    <div class="post_wrapper_tip">0至6岁是关键​</div>
                    <div class="post_wrapper_1">
                       若诞下了一位唐氏综合症的小孩，家长有什么需要注意和做的？协会代表谢小姐说道：「出生后在0至6岁是关键。」
                    </div>
                     <div class="post_wrapper_1">
                       「患有唐氏综合症的小孩都会有轻至中等程度的智力缺陷，出生时肌肉也很弱，部分更可能伴随先天的心脏病。所以在0至6岁小孩学习最佳和成长最快的时间，给予小孩充足的照顾和训练，或在需要的时候动手术十分重要。」
                    </div>
                     <div class="post_wrapper_1">
                       唐氏综合症的小孩成长后，会否有能力照顾自己，或发展自我的才能力？ 「可以的，虽然他们普遍学习缓慢，但只要给予时间和耐性，都可以学得一技之长。当然太复杂的工作他们可能应付不来，但他们成年后都可以自我照顾，和从事社会上工作。如我所认识的一位患病女孩，她不但学会了跳舞，现在还是一个芭蕾舞团的成员呢。」
                    </div>
                      <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/170903-down-syndrome.jpg"/>
                        <div class="bottom_tip">唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失，那在香港的情况又如何？</div>
                    </div> 
                    <div class="post_wrapper_tip">香港产前检查与现况</div>
                    <div class="post_wrapper_1">
                       今天在香港产前检查，主要在怀孕第10至13周进行。医护人员会使用超声波检查胎儿颈皮厚度，和抽血检验荷尔蒙，以评估胎儿患上各类遗传病的风险和染色体是否正常，准确度约80至90%。若对测试呈阳性反应，可以选择进一步进行羊膜穿刺术（俗称抽羊水）或抽取绒毛的侵入性检查方法进行更准确的确认。这类传统检查可在公立医院和母婴健康院免费进行。
                    </div>
                     <div class="post_wrapper_1">
                       若不希望进行传统的侵入性检查，亦可在私人医疗机构进行一款无创的检查方法。这种无创检查方法由香港中文大学卢煜明教授发明，方法是从孕妇的血液中直接寻找和检验婴孩染色体的状况。检查准确度高达99%以上，亦可免除因侵入性检查造成的流产风险。
                    </div>
                     <div class="post_wrapper_1">
                        若检查呈阴性反应，在第19至20周可再进行一次超声波检查，在两层检查下基本上已可准确预测胎儿状况。
                    </div>

                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/170903-hkdsa.jpg"/>
                        <div class="bottom_tip">唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失，那在香港的情况又如何？</div>
                    </div>
                     <div class="post_wrapper_tip">香港大多数孕妇亦选择人工流产​</div>
                    <div class="post_wrapper_1">
                       若在无任何产前检查的情况下，婴儿患上唐氏综合症的风险是多少？
                    </div>
                     <div class="post_wrapper_1">
                       一位不愿具名的香港执业资深妇产科医生表示：「唐氏综合症是遗传病中最常见的一种，若无任何产前检查和预防措施下，诞下唐氏综合症婴孩的机率约是3%。」
                    </div>
                     <div class="post_wrapper_1">
                        「其实今天香港孕妇在得悉婴儿有高机会患上唐氏综合症后，除非有特别原因，如宗教理由，一般都会选择人工流产。在我执业这么多年，从未接生过一位患上唐氏综合症的婴孩，因为所有在我诊所里已得知的，全都选择人工流产了。」
                    </div>
                     <div class="post_wrapper_1">
                        他续称，现今的产前检查，除了检查第21条染色体，即患上唐氏综合症会发生变异的染色体外，亦会检查第13条和18条染色体。这分别是检查巴陶氏症和爱德华氏症两种遗传病：「很可惜的是，若这两条染色体变异，婴儿可能会胎死腹中或出世后不久死亡，比唐氏综合症严重得多。」
                    </div>
                    
                   
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/170903-down-syndrome-patient.jpg"/>
                        <div class="bottom_tip">唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失，那在香港的情况又如何？</div>
                    </div>
                    <div class="post_wrapper_tip">人工流产引发优生学争论？ 最重要是孕妇自行决定</div>
                    <div class="post_wrapper_1">
                       香港未有一个确切的唐氏综合症数据，按上述资深妇产科医生说法，港人亦正以产前检查与中止怀孕的方法，减少患上唐氏综合症婴孩出生的比率。如此一来，会构成「优生学」的道德争论吗？这位医生并不同意。
                    </div>
                     <div class="post_wrapper_1">
                       「若你说拒绝产前检查与中止怀孕是回归自然的方法，那我告诉你，人类今天医疗的进步本来就不是自然的行为。女性在100年前的平均寿命只有40至50岁，原因是怀孕产子死亡机会甚高，但在人类医学进步下，怀孕产子已不再是风险，女性平均寿命大幅提升。这种非自然结果是科技进步带来的，产前检查的技术亦一样，所以你问会否构成『优生学』是问错了问题。」
                    </div>
                     <div class="post_wrapper_1">
                        唐氏综合症协会代表谢小姐这样回应：「我认为产前检查的目的，是为了让父母能有一个『准备』，这个准备可以让他们免于在诞下唐氏综合症小孩时感到彷徨。至于得悉结果后要否选择人工流产，这是他们的决定。」
                    </div>
                     <div class="post_wrapper_1">
                        在香港，产前检查属自愿性质，但在完善的医疗配套下，产前检查不论在公立医院或私家医疗机构均可进行，让大部分怀孕女性都能得悉胎儿的健康状况，而是否进行人工流产亦交由父母们决定。香港的现况，似乎已与欧洲或其他国家并无太大分别。
                    </div>
                    <div class="post_wrapper_1">
                        參考資料：<a href="https://www.hk01.com/%E5%8D%B3%E6%99%82%E5%9C%8B%E9%9A%9B/115669/%E6%98%9F%E6%9C%9F%E6%97%A5%E5%B0%88%E9%A1%8C-%E6%B6%88%E5%A4%B1%E4%B8%AD%E7%9A%84%E5%94%90%E6%B0%8F%E7%B6%9C%E5%90%88%E7%97%87-%E9%A6%99%E6%B8%AF%E5%AD%95%E5%A9%A6%E7%94%A2%E6%AA%A2%E8%88%87%E4%B8%AD%E6%AD%A2%E6%87%B7%E5%AD%95%E7%8F%BE%E6%B3%81">
                       香港01 </a>
                    </div>
                    
               </div>
           </div>
          <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    ul{
                            list-style-position: inside;
                            display: block;
                            list-style-type: disc;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px;
                            padding-inline-start: 40px;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/genseleven.vue